export default "__VITE_ASSET__19297ef5__"